import { Badge } from "./Badge";
import type { TournamentStatus } from "@/types/api";

const LABEL: Record<TournamentStatus, string> = {
  draft: "Черновик",
  registration: "Открыта запись",
  full: "Мест нет",
  in_progress: "Идёт",
  completed: "Завершён",
  cancelled: "Отменён",
};

// Палитра-«светофор»: оранжевый — запись открыта (делай), жёлтый — мест
// нет / переполнение, зелёный — идёт прямо сейчас, красный — матч уже
// закрыт (завершён или отменён, дальше ничего не сделаешь).
const KIND = {
  draft: "neutral",
  registration: "brand",
  full: "warning",
  in_progress: "success",
  completed: "live",
  cancelled: "live",
} as const;

export function TournamentStatusBadge({ status }: { status: TournamentStatus }) {
  return <Badge kind={KIND[status]}>{LABEL[status]}</Badge>;
}
